import PropTypes from 'prop-types';
// form
import { useFormContext, Controller, InputAdornment } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';
// Icons

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
  startAdornment: PropTypes.bool,
  endAdornment: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  inputProps: PropTypes.object,
  sx: PropTypes.object,
  multiLine: PropTypes.bool,
  rowsNumber: PropTypes.number,
};

export default function RHFTextField({
  name,
  helperText,
  startAdornment,
  endAdornment,
  disabled,
  type,
  inputProps,
  sx,
  multiLine,
  rowsNumber,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          disabled={disabled || false}
          {...field}
          fullWidth
          multiline={multiLine || false}
          rows={rowsNumber || 'default'}
          sx={sx}
          type={type && type}
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          itemprops={inputProps}
          {...other}
        />
      )}
    />
  );
}
